import { Paper } from "@mantine/core";
import { partnerApi } from "apis/partnerApi";
import { Loading } from "components";
import { ErrorStatusType } from "constants/types/common";
import { PartnerCreateBodyType, PartnerResponseType } from "constants/types/partner";
import { useFormik } from "formik";
import { FORM_IDS } from "pages/Partner/config";
import { FC, useState } from "react";
import { useNotification } from "utils/hooks";
import { useListRegion } from "utils/hooks/request/useRegions";
import PartnerFormFields from "../PartnerFormFields/PartnerFormFields";
import { editValidationSchema } from "./config";

interface EditFormProps {
  partner: PartnerResponseType;
  onClose?: () => void;
  mutate?: () => void;
}

const EditForm: FC<EditFormProps> = ({ partner, onClose, mutate }) => {
  const { notification } = useNotification();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const {
    regionOptions,
    isLoading: isRegionLoading,
    mutate: regionMutate,
  } = useListRegion();

  const formik = useFormik<PartnerCreateBodyType>({
    initialValues: {
      code: partner.code,
      name: partner.name,
      type: partner.type,
      regionId: partner.regionId,
      phone: partner.phone,
      taxCode: partner.taxCode,
      contactPersonId: partner.contactPersonId ?? "",
      address: partner.address ?? "",
      notes: partner.notes ?? "",
      isActive: partner.isActive,
    },
    validationSchema: editValidationSchema,
    enableReinitialize: true,
    onSubmit: async (values) => {
      setIsSubmitting(true);
      try {
        const res = await partnerApi.update(partner.id, values);
        if (res.data.success) {
          notification.success({ title: "Cập nhật đối tác thành công" });
          onClose?.();
          mutate?.();
        }
      } catch (error: ErrorStatusType | any) {
        notification.error({
          title: "Cập nhật đối tác thất bại",
          message: error?.error?.message,
        });
      }
      setIsSubmitting(false);
    },
  });

  const isLoading = isSubmitting || isRegionLoading;

  return (
    <Loading variant="overlay" visible={isLoading}>
      <Paper>
        <form id={FORM_IDS.EDIT} onSubmit={formik.handleSubmit}>
          <PartnerFormFields
            formik={formik}
            regionOptions={regionOptions}
            onRegionMutate={regionMutate}
          />
        </form>
      </Paper>
    </Loading>
  );
};

export default EditForm;
